import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppModule } from './app.module';
import { CmsAuthInterceptor } from './common/_services/connect/cms.service';
import { FeatureFlagService } from './common/_services/featureFlag.service';
import { ThemeConfig } from '../assets/data/enum/themeConfig';

function initFeatureFlagsFactory() {
  const ff = inject(FeatureFlagService);
  const theme = ThemeConfig;

  return async () => {
    const context = {
      key: 'all-users',
      kind: 'user',
      custom: { saas: theme.brand },
    };
    await ff.initialize(context); // Promise<void>
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, AppModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: CmsAuthInterceptor, multi: true },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.darkmode',
        },
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initFeatureFlagsFactory,
      multi: true,
    },
  ],
};
